import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./i18n";
import AppView from "./views/app/App.view";
import { ToastContainer } from "react-toastify";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import { LoggingProvider } from "./provider/logging/Logging.provider.tsx";
import ErrorView from "./views/error/Error.view.tsx";
import ErrorBoundaryWrapper from "./boundary/error/ErrorBoundary.wrapper.tsx";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { QueryProvider } from "./provider/query/Query.provider.tsx";

ModuleRegistry.registerModules([AllCommunityModule]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <StrictMode>
    <QueryProvider>
      <LoggingProvider>
        <ErrorBoundaryWrapper fallback={<ErrorView />}>
          <ToastContainer style={{ zIndex: 90000 }} />
          <AppView />
        </ErrorBoundaryWrapper>
      </LoggingProvider>
    </QueryProvider>
  </StrictMode>,
);
